import $ from 'jquery/dist/jquery.slim.min';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import 'regenerator-runtime/runtime';

import * as d3 from 'd3';

import {Spinner} from 'spin.js';
import 'spin.js/spin.css';

import * as images from './images';
import * as solutionMaps from './solutionMaps';
import '../css/main.css';

const spinColour = '#ffffff';


const opts = {
    lines:     12,
    length:    5,
    width:     3,
    radius:    9,
    scale:     0.8,
    corners:   1,
    color:     spinColour,
    fadeColor: 'transparent',
    speed:     1.1,
    rotate:    0,
    animation: 'spinner-line-fade-quick',
    direction: 1,
    zIndex:    2e9,
    className: 'spinner',
    shadow:    '0 0 1px transparent',
    position:  'absolute'
};


function mam(assetID, size) {
    return 'http://www.nhm.ac.uk/services/media-store/asset/' + assetID
           + '/contents/' + size;
}

function portalSearch(assetID) {
    return 'http://data.nhm.ac.uk/dataset/56e711e6-c847-4f99-915a-6894bb5c5dea/resource/05ff2255-c38a-40c9-b657-4ccb55ab2feb?q=' +
           assetID;
}

function displayComposite(rawSolutionMap, imgPath) {
    return new Promise(function (resolve, reject) {
        // clear the previous
        let gridDiv = d3.select('#grid');

        gridDiv.selectAll('svg').remove();
        d3.selectAll('.tooltip').remove();
        d3.selectAll('#loader').remove();

        // get the bounds
        const mapWidth = d3.max(d3.entries(rawSolutionMap), function (d) {
            return parseInt(d.key.split('|')[0]);
        });

        const mapHeight = d3.max(d3.entries(rawSolutionMap), function (d) {
            return parseInt(d.key.split('|')[1]);
        });

        const windowWidth = $(window).width() - 50;
        const windowHeight = $(window).height() - ($('#top-block').height() + $('#bottom-block').height() + 75);

        let maxPixelWidth = windowWidth / (mapWidth + 1);
        let maxPixelHeight = windowHeight / (mapHeight + 1);
        let pixelSize = Math.min(maxPixelWidth, maxPixelHeight);

        // add all the elements
        let gridContainer = gridDiv.append('svg')
                                   .attr('width', (mapWidth + 1) * pixelSize)
                                   .attr('height', (mapHeight + 1) * pixelSize);

        let gridBg = gridContainer.append('image')
                                  .attr('width', (mapWidth + 1) * pixelSize)
                                  .attr('height', (mapHeight + 1) * pixelSize)
                                  .attr('xlink:href', imgPath);

        let grid = gridContainer.append('g');

        let tooltip = d3.select('body')
                        .append('div')
                        .attr('class', 'tooltip')
                        .style('opacity', 0);

        let loader = d3.select('body')
                       .append('div')
                       .attr('id', 'loader');

        // process the map - transform into an array of x, y, thumb, url
        let solutionMap = d3.entries(rawSolutionMap).map(function (d, i) {
            try {
                let xy = d.key.split('|');
                let thumbPath = d.value.path.split('/');
                let assetID = thumbPath[thumbPath.length - 1].split('.')[0];
                return {
                    ix: (xy[1] * mapWidth) + xy[0],
                    x:       xy[0] * pixelSize,
                    y:       xy[1] * pixelSize,
                    thumb:   d.value.path,
                    assetId: assetID
                };
            }
            catch (e) {
                console.log(i);
                console.log(e);
                console.log(d);
            }
        });

        // add hover cells
        let cells = grid.selectAll('.cell')
                        .data(solutionMap.sort(function (a,b) {
                            return a.ix - b.ix;
                        }))
                        .enter()
                        .append('rect')
                        .attr('class', 'cell')
                        .attr('width', pixelSize)
                        .attr('height', pixelSize)
                        .attr('x', function (d) {
                            return d.x;
                        })
                        .attr('y', function (d) {
                            return d.y;
                        })
                        .style('fill', '#ffffff00');

        cells.on("mouseover", function (d) {
            d3.select(this).style('stroke', spinColour);

            let xPos = d3.event.pageX;
            let yPos = d3.event.pageY;
            let x = (xPos) + 'px';
            let y = (yPos) + 'px';
            tooltip.style('left', x)
                   .style('top', y);
            loader.style('left', x)
                  .style('top', y);
            let target = document.getElementById('loader');
            let spinner = new Spinner(opts).spin(target);

            let img = new Image();
            img.src = mam(d.assetId, 'thumbnail');
            tooltip.html(img.outerHTML);
            // img.onloadstart =
            img.onload = function () {
                if (img.width + xPos >= $(window).width()) {
                    tooltip.style('left', (xPos - img.width) + 'px');
                }
                spinner.stop();
                tooltip.transition()
                       .duration(500)
                       .style('opacity', 1);
            }
        })
             .on('mouseout', function (d) {
                 d3.select(this).style('stroke', 'none');
                 tooltip.transition()
                        .duration(200)
                        .style('opacity', 0);
                 tooltip.html('');
             })
             .on('click', function (d) {
                 window.open(portalSearch(d.assetId), '_blank')
             });

        resolve(solutionMap.length);
    });
}

async function drawComposite(rawSolutionMap, imgPath) {
    let mapSize = await displayComposite(rawSolutionMap, imgPath);
}

let changeImage = function (link) {
    let target = link.data().target;
    $('.nav-link').removeClass('active');
    link.addClass('active');
    drawComposite(solutionMaps[target], images[target]);
};

$(document).ready(function () {
    $('.nav-link').click((event) => {
        let link = $(event.delegateTarget);
        changeImage(link);
    });
    $('#linnaeus-link').click();
});

$(window).resize(() => {
    let link = $('.nav-link.active');
    changeImage(link);
})
